import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiName } from "../Constant/ApiName";
import { fetchApiGet } from "../utils/FetchApi";
import SubscriptionPage from "../pages/SubscriptionPage";
import { getCookie } from "../utils/CommonFunction";

type Props = {
  isSubscribe: boolean;
  handleLogout: () => void;
  handleUnSubscribe: () => void;
  loader: boolean;
  jwtToken: string | null;
  errorMsg: string;
};

const SubscriptionScreen = (props: Props) => {
  const data = getCookie("data");
  const [packageList, setPackageList] = useState<any>([]);
  const [isLoader, setIsLoader] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpenSuccess, setModalOpenSuccess] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => {
    setModalOpen(false);
    navigate("/home");
  };
  const openModalSuccess = () => setModalOpenSuccess(true);
  const closeModalSuccess = () => {
    setModalOpenSuccess(false);
    navigate("/home");
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (props.jwtToken) {
      getPackageList();
    }
  }, [props.jwtToken]);

  const getPackageList = async () => {
    try {
      let endPoint = ApiName.package_list + "?msisdn=" + data?.msisdn;
      let response = await fetchApiGet(props.jwtToken, endPoint);
      if (response.status === 200) {
        const _temp = response.results.filter(
          (item: any) => item.status === true
        );

        if (_temp.length == 0) {
          openModal();
        }
        setPackageList(response.results);
        console.log(response.results);
      } else {
        openModal();
        console.log("Something went Wrong");
      }
    } catch (error) {
      console.log("Something went Wrong", error);
    }
  };

  const onHandleChangePackage = async (index: number) => {
    try {
      const old_id = packageList
        .filter((item: any) => item.status === true)
        .map((item: any) => item.id);

      let endPoint =
        ApiName.changePackageWeb +
        "?msisdn=" +
        data?.msisdn +
        "&new_package_id=" +
        index +
        "&old_package_id=" +
        old_id;

      const date = new Date();
      localStorage.setItem("packageChangeTime", date.toString());
      let response = await fetchApiGet(props.jwtToken, endPoint);
      if (response.status === 200) {
        openModalSuccess();
      } else {
        console.log("Something went Wrong");
      }
    } catch (error) {
      console.log("Something went Wrong", error);
    }
  };

  return (
    <SubscriptionPage
      isSubscribe={props.isSubscribe}
      handleLogout={props.handleLogout}
      handleUnSubscribe={props.handleUnSubscribe}
      loader={props.loader}
      jwtToken={props.jwtToken}
      errorMsg={props.errorMsg}
      closeModal={closeModal}
      closeModalSuccess={closeModalSuccess}
      onHandleChangePackage={onHandleChangePackage}
      packageList={packageList}
      isModalOpen={isModalOpen}
      isModalOpenSuccess={isModalOpenSuccess}
    />
  );
};

export default SubscriptionScreen;
